import ServerUsersModal, {
  ServerUsersModalDispatchProps,
  ServerUsersModalOwnProps,
} from '../../components/administration/serverUsersModal'
import { showMessage } from '@/modules/shared/stores/messageStore'
import { MessageModel } from 'app/models/messageModel'
import { getServerUsers, setServerUsers } from 'app/actions/server'
import UserAPI from 'app/services/user/userApi'
import * as React from 'react'
import { withActions } from '@/modules/shared/hocs/withActions'

export function mapDispatchToProps(): ServerUsersModalDispatchProps {
  return {
    showMessage: (message: MessageModel) => showMessage(message),
    getServerUsers: (serverId: string) => getServerUsers(serverId),
    setServerUsers: (serverId: string, userIds: string[]) =>
      setServerUsers(serverId, userIds),
    getAllUsers: () => UserAPI.create().getUsers(),
  }
}

export default withActions(
  ServerUsersModal as any,
  mapDispatchToProps(),
) as unknown as React.ComponentClass<ServerUsersModalOwnProps>
